export default {
    sidebarState(state) {
        return state.sidePanelSettings;
    }
}